/**
 * 阿里云验证码配置和类型定义
 */

export interface AliyunCaptchaConfig {
  /** 验证码示例所属地区，支持中国内地（cn）、新加坡（sgp） */
  region: "cn" | "sgp";
  /** 身份标 */
  prefix: string;
}

export interface AliyunCaptchaInitOptions {
  /** 场景ID */
  SceneId: string;
  /** 验证码模式 */
  mode: "popup" | "embed";
  /** 页面上预留的渲染验证码的元素 */
  element?: string;
  /** 触发验证码弹窗的元素 */
  button?: string;
  /** 业务请求(带验证码校验)回调函数 */
  captchaVerifyCallback: (
    captchaVerifyParam: string
  ) => Promise<CaptchaVerifyResult>;
  /** 业务请求结果回调函数 */
  onBizResultCallback?: (bizResult: boolean) => void;
  /** 绑定验证码实例函数 */
  getInstance: (instance: AliyunCaptchaInstance) => void;
  /** 滑块验证码样式 */
  slideStyle?: {
    width: number;
    height: number;
  };
  /** 验证码语言类型 */
  language?: "cn" | "tw" | "en";
}

export interface CaptchaVerifyResult {
  /** 验证码验证是否通过 */
  captchaResult: boolean;
  /** 业务验证是否通过 */
  bizResult?: boolean;
}

export interface AliyunCaptchaInstance {
  /** 显示验证码 */
  show: () => void;
  /** 隐藏验证码 */
  hide: () => void;
  /** 重置验证码 */
  reset: () => void;
}

declare global {
  interface Window {
    AliyunCaptchaConfig?: AliyunCaptchaConfig;
    initAliyunCaptcha?: (options: AliyunCaptchaInitOptions) => void;
  }
}

// 从环境变量获取配置
export const CAPTCHA_CONFIG = {
  region: "sgp",
  prefix: "1y106u",
  sceneId: "1dc08srr",
};
